import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { Objective, User, UserType, Activity, Project } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SharedDataService, SortDirection } from 'elbuild-ui-lib-core';
import { Subscription, Observable, combineLatest, forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-objective-list',
	templateUrl: './objective-list.component.html',
	styleUrls: ['./objective-list.component.scss']
})
export class ObjectiveListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: Objective[];

	advancedSearch: Search = new Search('objective', 'concat(name)', 'objective');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	@ViewChild('datatable', {}) datatable: DatatableComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	projectid: number;
	project: Project;
	loggedUser: User;
	subcription: Subscription;

	@Input()
	usercompanyid: number;

	constructor(
		private objectiveService: CrudService<Objective>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService,
		private activityService: CrudService<Activity>,
		private projectService: CrudService<Project>) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');


	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			if (this.loggedUser.utype === UserType.company) {
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {
		if (this.projectid) {
			this.projectService.getEntity(Project, 'project', this.projectid).subscribe((p: Project) => this.project = p);
		}

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projectid', this.projectid);
		}

		const datarequest = this.objectiveService.searchEntities(Objective, 'objective', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.objectiveService.countEntities(Objective, 'objective', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any) {
		if (event.type === 'dblclick' && this.datatable && this.datatable.rowDetail && event.row) {
			this.datatable.rowDetail.toggleExpandRow(event.row);
		}
	}



	onActivateActivity(activityid: any) {
		this.router.navigate([`/project/objective/activity/view/${activityid}`], { queryParamsHandling: 'merge' });
	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: Objective, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-objective-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.objectiveService.deleteEntity(Objective, 'objective', row).subscribe(() => {
					this.translateService.get(['labels.objective-deleted', 'labels.objectives']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.objective-deleted'], messages['labels.objectives']);
						this.load();
					});
				});
			}
		});
	}

	deleteActivity(row: Activity, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-activity-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.activityService.deleteEntity(Activity, 'activity', row).subscribe(() => {
					this.translateService.get(['labels.activity-deleted', 'labels.activities']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.activity-deleted'], messages['labels.activities']);
						this.load();
					});
				});
			}
		});
	}

}
